import styled from "styled-components";
import {Container} from "react-bootstrap";


export const PageFilesContainer = styled.section`
  margin: 0;
  
`

export const PageFilesAction = styled.div`
  position: sticky;
  top: 80px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  background: white;
  padding: 10px 10px 20px 10px;
  z-index: 50;

  @media (max-width: 760px) {
    top: 52px;
    button {
      span {
        display: none;
      }
    }
  }
`

export const PageFilesContent = styled.div`
  padding: 0 10px 0 10px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 20px;

  //max-height: 60px;
  @media (max-width: 1400px) {
    grid-template-columns: repeat(6, 1fr);
  }

  @media (max-width: 1200px) {
    grid-template-columns: repeat(5, 1fr);
  }

  @media (max-width: 1000px) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (max-width: 760px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
  }
`
